/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_3fc27b28"]'><div :class='["radio-ui-right-demo"]'><view-desc>图标展示在右侧: {{ radioValue }}</view-desc><div :class='["cube-radio-demos"]'><cube-radio :option="(radio1)" :value="radioValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","radioValue", "__mpx_event__", ["value"], undefined]])'></cube-radio><cube-radio :option="(radio2)" :value="radioValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","radioValue", "__mpx_event__", ["value"], undefined]])'></cube-radio></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_3fc27b28"}'>
// .radio-ui-right-demo
//   .cube-radio-example
//     padding 5px 10px
//     box-sizing border-box
//     background-color #fff
//   .desc
//     margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_3fc27b28"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_3fc27b28"}
  /** script content **/
  require("./radio-ui-right.mpx.js?isComponent&outputPath=components%2Fradio-ui-right3fc27b28%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio-ui-right.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio-ui-right3fc27b28%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_3fc27b28"],
    ctorType: "component",
    outputPath: "components/radio-ui-right3fc27b28/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio/index.mpx?isComponent&outputPath=components%2Findex4aa5b228%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>